<fieldset class="fieldset" title="test">
  <legend class="fieldset__legend">{{ label }}</legend>
  <ng-content></ng-content>
</fieldset>
